<template>
  <div>
    <transition name="slide-right" v-show="visible">
      <div
        :class="[
          'tw-w-full tw-grid tw-fixed tw-inset-0 md:tw-rounded-l-[12px] tw-bg-white border tw-max-w-full',
          headerTitle && 'tw-grid-rows-[auto_1fr_auto]',
          !headerTitle && 'tw-grid-rows-[1fr_auto]',
          width === 'tn' && 'md:tw-w-[360px]',
          width === 'sm' && 'md:tw-w-[576px]',
          width === 'md' && 'md:tw-w-[899px]',
          width === 'lg' && 'md:tw-w-[80%] md:tw-max-w-[1200px]',
          width === 'xl' && 'md:tw-w-[1270px]',
          width === '2xl' && 'md:tw-w-[1342px]',
        ]"
        :style="{
          'z-index': zIndex + 1,
          // 'z-index': 1060
        }"
      >
        <header
          class="tw-flex tw-justify-between tw-items-center tw-min-h-[84px] tw-border-b tw-border-blue-dark-50 tw-text-blue-dark-500 tw-p-6"
          v-if="headerTitle"
        >
          <div>
            <base-icon
              :icon="headerIcon"
              class="fs-21 tw-align-middle tw-ml-3"
            ></base-icon>
            <h3
              v-html="headerTitle"
              class="tw-inline-block !tw-font-bold tw-text-small"
            ></h3>
          </div>
          <div class="tw-flex tw-items-center">
            <base-icon
              icon="close"
              class="c-pointer fs-21"
              @click="closed()"
            ></base-icon>
          </div>
        </header>

        <!--    Body    -->
        <div
          class="overflow-y-auto md:tw-overflow-hidden"
          :class="[!$slots.footer && 'md:tw-rounded-bl-[12px]', bodyClass]"
        >
          <slot name="body" />
        </div>

        <footer
          v-if="$slots.footer"
          class="tw-flex tw-flex-wrap tw-gap-[12px] tw-p-6 tw-pb-5 tw-justify-end tw-min-h-[84px] tw-items-center tw-border-t tw-border-blue-dark-50"
          :class="footerClass"
        >
          <slot name="footer" />
        </footer>
      </div>
    </transition>
    <div
      v-show="visible"
      class="right-sidebar-backdrop"
      :style="{
        'z-index': zIndex,
      }"
      @click.self="closed()"
    ></div>
  </div>
</template>

<script setup>
import { ref, watch, getCurrentInstance, defineEmits, defineProps } from 'vue'
import BaseIcon from '@/components/base/BaseIcon.vue'

const { proxy } = getCurrentInstance()
const showMoreDetail = ref(false)
const zIndex = ref(1050)

const props = defineProps({
  visible: { type: Boolean, default: false },
  headerTitle: { type: String, default: null },
  headerIcon: { type: String, default: 'info-bold' },
  width: { type: String, default: 'sm' },
  bodyClass: { type: String, default: '' },
  footerClass: { type: String, default: '' },
})

const emit = defineEmits(['update:visible', 'close'])

const closed = () => {
  emit('update:visible', false)
  emit('close', true)
}

// قفل کردن scroll وقتی بازه
watch(
  () => props.visible,
  (val) => {
    document.body.style.overflow = val ? 'hidden' : ''
  },
)

const calc_and_set_z_index = () => {
  zIndex.value = proxy.$getModalZIndex() || 1050
}

watch(
  () => props.visible,
  (val) => {
    if (val) {
      calc_and_set_z_index()
      // document.body.style.overflow = 'hidden'
    } else {
      // document.body.style.overflow = ''
    }
  },
)
</script>

<style>
.right-sidebar-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: flex-start;
  transition: opacity 0.2s ease;
}

.right-sidebar {
  border-radius: 0.75rem 0 0 0.75rem;
  box-shadow: -8px 0px 40px rgba(176, 212, 250, 0.35);
}

.btn-close {
  background: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
}

/* انیمیشن باز و بسته شدن */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.3s ease, opacity 0.1s ease;
}

.slide-right-enter-from,
.slide-right-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
</style>
